import Tabs, { TabsProps } from './Tabs';
import { TabPaneProps } from './TabPane';
import { TabGroupProps } from './TabGroup';
export { TabsProps, TabPaneProps, TabGroupProps, };
export default Tabs;
